import { MAX_ALERT_COUNT } from '@xing-com/crate-jobs-constants';

import { useSearchAlerts } from './use-search-alerts';

// The max logic is extracted so that other components can check if without the
// need of re-calculating most of the logic inside useToggleSearchAlert

export const useIsSearchAlertsMaxReached = (): boolean => {
  const { data } = useSearchAlerts();
  if (
    !data ||
    data?.viewer?.searchAlerts?.__typename !== 'SearchAlertResultResponse'
  ) {
    return false;
  }

  const { collection } = data.viewer.searchAlerts;
  return (collection?.length ?? 0) >= MAX_ALERT_COUNT;
};
